import React from "react";
import Reveal from "./Reveal";

function Section({ id, title, accent, children }) {
  return (
    <section id={id} className="section">
      <div className="container">
        <Reveal as="h2" className="section-title">
          {title} <span className="gradient-text">{accent}</span>
          <span className="title-bar" />
        </Reveal>
        {children}
      </div>
    </section>
  );
}

export default Section;
